import {
  UPDATE_MY_SURVEYS_LIST,
  TOGGLE_MY_SURVEYS_LIST_LOADING,
  MY_SURVEYS_LIST_ERROR,
  MY_SURVEYS_UPDATE_TOTAL_LIST,
  // about me
  MY_SURVEYS_ABOUT_ME_UPDATE_LIST,
  MY_SURVEYS_ABOUT_ME_TOGGLE_LOADING,
  MY_SURVEYS_ABOUT_ME_UPDATE_ERROR,
  // about my classes
  MY_SURVEYS_ABOUT_MY_CLASSES_UPDATE_LIST,
  MY_SURVEYS_ABOUT_MY_CLASSES_TOGGLE_LOADING,
  MY_SURVEYS_ABOUT_MY_CLASSES_UPDATE_ERROR,
} from "../actions/dataEntryMySurveysActions";

const initState = {
  name: "Data Entry My Surveys",
  mySurveys: {
    loading: true,
    list: [],
    error: null,
    totalRecords: 0,
  },
  aboutMe: {
    loading: true,
    list: [],
    error: null,
    totalRecords: 0,
  },
  aboutMyClasses: {
    loading: true,
    list: [],
    error: null,
    totalRecords: 0,
  },
};

const dataEntryMySurveysReducer = (state = initState, action) => {
  const newState = { ...state };

  switch (action.type) {
    case UPDATE_MY_SURVEYS_LIST:
      newState.mySurveys.list = action.payload.value;
      break;
    case TOGGLE_MY_SURVEYS_LIST_LOADING:
      newState.mySurveys.loading = action.payload.value;
      break;
    case MY_SURVEYS_LIST_ERROR:
      newState.mySurveys.error = action.payload.value;
      break;
    case MY_SURVEYS_UPDATE_TOTAL_LIST:
      newState.mySurveys.totalRecords = action.payload.value;
      break;
    case MY_SURVEYS_ABOUT_ME_UPDATE_LIST:
      newState.aboutMe.list = action.payload.data;
      newState.aboutMe.totalRecords = action.payload.count;
      break;
    case MY_SURVEYS_ABOUT_ME_TOGGLE_LOADING:
      newState.aboutMe.loading = action.payload.loading;
      break;
    case MY_SURVEYS_ABOUT_ME_UPDATE_ERROR:
      newState.aboutMe.error = action.payload.error;
      break;
    case MY_SURVEYS_ABOUT_MY_CLASSES_UPDATE_LIST:
      newState.aboutMyClasses.list = action.payload.data;
      newState.aboutMyClasses.totalRecords = action.payload.count;
      break;
    case MY_SURVEYS_ABOUT_MY_CLASSES_TOGGLE_LOADING:
      newState.aboutMyClasses.loading = action.payload.loading;
      break;
    case MY_SURVEYS_ABOUT_MY_CLASSES_UPDATE_ERROR:
      newState.aboutMyClasses.error = action.payload.error;
      break;
    default:
      break;
  }
  return newState;
};

export default dataEntryMySurveysReducer;
